import { ActionsColumn as ActionsColumnCommon, IconType } from '@otp/ui';
import styles from './index.module.css';
import React from 'react';
import { PartialMostScheduledJobListType } from 'src/components/most/list/scheduled-jobs/types';
import { DeleteAction } from 'src/components/most/list/scheduled-jobs/table/columns/actions/delete';
import { EditAction } from 'src/components/most/list/scheduled-jobs/table/columns/actions/edit';
import { Can } from 'src/utils/can';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';
import { useCan } from 'src/utils/can';

type ActionsColumProps = {
  mostScheduledJob: PartialMostScheduledJobListType;
};

export const ActionsColumn = ({ mostScheduledJob }: ActionsColumProps) => {
  const { can } = useCan();
  const canDelete = can({
    action: Actions.Write,
    subject: Subjects.Jobs,
    appArea: AppArea.Most,
  });
  const canEdit = can({
    action: Actions.Write,
    subject: Subjects.Jobs,
    appArea: AppArea.Most,
  });

  const icons = [
    canEdit && {
      icon: <EditAction mostScheduledJob={mostScheduledJob} />,
    },
    canDelete && {
      icon: <DeleteAction mostScheduledJob={mostScheduledJob} />,
    },
  ].filter(Boolean) as IconType[];

  return (
    <Can I={Actions.Write} a={Subjects.Jobs} appArea={AppArea.Most}>
      <div onClick={(e) => e.stopPropagation()}>
        <ActionsColumnCommon
          icons={icons}
          className="justify-end"
          classes={{ menu: styles.actionsColumn }}
        />
      </div>
    </Can>
  );
};
